export const lessonCards = [
    { // 1
        id: 1,
        title: "Apa Itu Python?",
        description: "Kenalan dulu sama Python: sejarah singkat, kelebihan, kegunaan, dan kenapa banyak dipakai pemula maupun expert.",
        level: "Pemula",
        duration: "1 jam",
        lessons: 4,
        progress: 0,
        image: "🐍",
        topics: [
            "Sejarah & Asal Usul",
            "Kenapa Python Populer?",
            "Bidang Penggunaan Python",
            "Program Pertama: Hello World"
        ],
        color: "#10B981",
    },
    { // 2
        id: 2,
        title: "Instalasi Python & VS Code",
        description: "Panduan install Python 3 dan Visual Studio Code di Windows & MacOS, termasuk setting awal biar siap ngoding.",
        level: "Pemula",
        duration: "1.5 jam",
        lessons: 4,
        progress: 0,
        image: "💻",
        topics: [
            "Download & Install Python di Windows",
            "Download & Install Python di MacOS",
            "Install Visual Studio Code",
            "Setting Awal VS Code untuk Python"
        ],
        color: "#F59E0B",
    },
    { // 3
        id: 3,
        title: "Cara Kerja Program & Bytecode",
        description: "Pelajari bagaimana Python menjalankan kode: dari source code, bytecode, hingga interpreter Python.",
        level: "Pemula",
        duration: "1.5 jam",
        lessons: 3,
        progress: 0,
        image: "⚙️",
        topics: [
            "Dari Source Code ke Bytecode",
            "Interpreter Python",
            "Eksperimen Bytecode"
        ],
        color: "#F29E93",
    },
    { // 4
        id: 4,
        title: "Mengenal Variabel",
        description: "Belajar tentang variabel di Python: apa itu variabel, cara membuatnya, aturan penamaan, tipe data dasar, dan latihan praktik.",
        level: "Pemula",
        duration: "1.5 jam",
        lessons: 5,
        progress: 0,
        image: "📦",
        topics: [
            "Apa Itu Variabel?",
            "Membuat Variabel",
            "Aturan Penamaan",
            "Tipe Data Dasar",
            "Latihan Praktik"
        ],
        color: "#3C467B",
    },
    { // 5
        id: 5,
        title: "Tipe Data di Python",
        description: "Belajar berbagai tipe data penting di Python: angka, string, boolean, list, tuple, set, dict, dan NoneType.",
        level: "Pemula",
        duration: "2 jam",
        lessons: 7,
        progress: 0,
        image: "📦",
        topics: [
            "Angka (int & float)",
            "String (str)",
            "Boolean (bool)",
            "List",
            "Tuple",
            "Set",
            "Dictionary (dict)",
            "NoneType",
            "Latihan"
        ],
        color: "#FA812F",
    },
    { // 6
        id: 6,
        title: "Casting Tipe Data di Python",
        description: "Belajar cara mengubah tipe data (casting) di Python: int, float, str, dan bool. Lengkap dengan contoh dan latihan.",
        level: "Pemula",
        duration: "1.5 jam",
        lessons: 4,
        progress: 0,
        image: "🔄",
        topics: [
            "Apa Itu Casting?",
            "Casting ke Integer & Float",
            "Casting ke String & Boolean",
            "Latihan Praktik"
        ],
        color: "#6F00FF",
    },
    { // 7
        id: 7,
        title: "Mengambil Input Data dari User",
        description: "Belajar cara menerima input dari pengguna dengan fungsi input(), mengolahnya, dan menampilkannya kembali.",
        level: "Pemula",
        duration: "1.5 jam",
        lessons: 3,
        progress: 0,
        image: "⌨️",
        topics: [
            "Fungsi input()",
            "Konversi Tipe Data",
            "Latihan Praktik"
        ],
        color: "#F39F9F",
    },
    { // 8
        id: 8,
        title: "Operasi Aritmatika di Python",
        description: "Pelajari cara melakukan operasi matematika dasar di Python, mulai dari tambah, kurang, kali, bagi, sampai modulus dan pangkat.",
        level: "Pemula",
        duration: "1.5 jam",
        lessons: 5,
        progress: 0,
        image: "➕",
        topics: [
            "Penjumlahan & Pengurangan",
            "Perkalian & Pembagian",
            "Modulus & Floor Division",
            "Pangkat",
            "Latihan Praktik"
        ],
        color: "#59AC77",
    },
    { // 9
        id: 9,
        title: "Latihan Perhitungan Sederhana",
        description: "Praktik dasar matematika di Python: penjumlahan, pengurangan, perkalian, pembagian, modulus, dan latihan mini-kalkulator.",
        level: "Pemula",
        duration: "1.5 jam",
        lessons: 4,
        progress: 0,
        image: "🧮",
        topics: [
            "Penjumlahan & Pengurangan",
            "Perkalian & Pembagian",
            "Modulus & Pangkat",
            "Latihan Mini-Kalkulator"
        ],
        color: "#DC143C",
    },
    { // 10
        id: 10,
        title: "Operasi Komparasi",
        description: "Belajar operator perbandingan di Python: ==, !=, >, <, >=, <=. Pahami gimana cara membandingkan nilai.",
        level: "Pemula",
        duration: "1 jam",
        lessons: 3,
        progress: 0,
        image: "⚖️",
        topics: [
            "Apa Itu Operator Komparasi?",
            "Contoh Pemakaian",
            "Latihan Soal"
        ],
        color: "#3396D3",
    },
    { // 11
        id: 11,
        title: "Operasi Logika & Boolean",
        description: "Pelajari tipe data boolean (True/False), operator logika (and, or, not), serta cara menggunakannya dalam kondisi.",
        level: "Pemula",
        duration: "1.5 jam",
        lessons: 4,
        progress: 0,
        image: "🔀",
        topics: [
            "Apa itu Boolean?",
            "Operator Logika",
            "Perbandingan & Boolean",
            "Latihan Praktik"
        ],
        color: "#FFD93D",
    },
    { // 12
        id: 12,
        title: "Latihan Komparasi dan Logika",
        description: "Latihan pemahaman operator perbandingan dan logika di Python. Dari membandingkan angka hingga menggabungkan kondisi dengan AND, OR, dan NOT.",
        level: "Menengah",
        duration: "2 jam",
        lessons: 5,
        progress: 0,
        image: "🧠",
        topics: [
            "Operator Perbandingan",
            "Operator Logika",
            "Kombinasi Kondisi",
            "Latihan Kasus",
            "Soal Praktik"
        ],
        color: "#154D71",
    },
    { // 13
        id: 13,
        title: "Operator Bitwise di Python",
        description: "Pelajari cara kerja operator bitwise (AND, OR, XOR, NOT, shift) untuk memanipulasi data biner di Python.",
        level: "Menengah",
        duration: "1.5 jam",
        lessons: 6,
        progress: 0,
        image: "🔢",
        topics: [
            "Apa Itu Bitwise?",
            "Operator AND (&)",
            "Operator OR (|)",
            "Operator XOR (^)",
            "Operator NOT (~)",
            "Shift Kiri & Kanan (<<, >>)",
            "Latihan"
        ],
        color: "#0046FF",
    },
    { // 14
        id: 14,
        title: "Operator Assignment di Python",
        description: "Belajar gimana cara pakai operator assignment (=, +=, -=, dll) buat nyimpen dan update nilai variabel dengan cara singkat.",
        level: "Pemula",
        duration: "1 jam",
        lessons: 3,
        progress: 0,
        image: "✍️",
        topics: [
            "Apa itu Operator Assignment?",
            "Macam-Macam Operator Assignment",
            "Latihan Praktik"
        ],
        color: "#D97D55",
    },
    { // 15
        id: 15,
        title: "Pengenalan String di Python",
        description: "Belajar dasar-dasar string, cara membuat, dan operasi sederhana dengan string di Python.",
        level: "Pemula",
        duration: "1 jam",
        lessons: 3,
        progress: 0,
        image: "📝",
        topics: [
            "Apa itu String?",
            "Cara Membuat String",
            "Latihan Praktik"
        ],
        color: "#4CAF50",
    },
    { // 16
        id: 16,
        title: "Operasi dan Manipulasi String (Part 1)",
        description: "Belajar operasi dasar string seperti concatenation, repetition, indexing, dan slicing.",
        level: "Pemula",
        duration: "1.5 jam",
        lessons: 3,
        progress: 0,
        image: "🔤",
        topics: [
            "Concatenation dan Repetition",
            "Indexing String",
            "Slicing String"
        ],
        color: "#2196F3",
    },
    { // 17
        id: 17,
        title: "Operasi dan Manipulasi String (Part 2)",
        description: "Belajar method-method string yang umum digunakan seperti upper(), lower(), strip(), replace(), dll.",
        level: "Pemula",
        duration: "2 jam",
        lessons: 3,
        progress: 0,
        image: "🛠️",
        topics: [
            "Method String Umum",
            "Pencarian dan Validasi",
            "Transformasi String"
        ],
        color: "#FF9800",
    },
    { //18
        id: 18,
        title: "Format String di Python",
        description: "Belajar berbagai cara formatting string: %-formatting, str.format(), dan f-string.",
        level: "Pemula Menengah",
        duration: "1.5 jam",
        lessons: 3,
        progress: 0,
        image: "🎨",
        topics: [
            "%-formatting (Lama)",
            "str.format() Method",
            "f-String (Modern)"
        ],
        color: "#9C27B0",
    },
    { // 19
        id: 19,
        title: "String Width and Alignment",
        description: "Belajar mengatur lebar, alignment, dan padding string untuk tampilan yang rapi.",
        level: "Menengah",
        duration: "1 jam",
        lessons: 3,
        progress: 0,
        image: "📐",
        topics: [
            "Text Alignment",
            "Width dan Padding",
            "Formatting Lanjutan"
        ],
        color: "#795548",
    },
    { // 20
        id: 20,
        title: "Latihan Date and Time",
        description: "Praktik penggunaan module datetime untuk manipulasi tanggal dan waktu.",
        level: "Pemula Menengah",
        duration: "2 jam",
        lessons: 3,
        progress: 0,
        image: "📅",
        topics: [
            "Module datetime Dasar",
            "Formatting Tanggal & Waktu",
            "Operasi DateTime"
        ],
        color: "#607D8B",
    },
    { // 21
        id: 21,
        title: "IF dan ELSE Statement",
        description: "Belajar dasar percabangan dengan IF dan ELSE untuk pengambilan keputusan dalam program.",
        level: "Pemula",
        duration: "1.5 jam",
        lessons: 3,
        progress: 0,
        image: "🔀",
        topics: [
            "Konsep Percabangan",
            "IF Statement",
            "ELSE Statement"
        ],
        color: "#E91E63",
    },
    { // 22
        id: 22,
        title: "ELIF Statement",
        description: "Belajar menggunakan ELIF untuk menangani multiple kondisi dalam percabangan.",
        level: "Pemula",
        duration: "1.5 jam",
        lessons: 3,
        progress: 0,
        image: "🔄",
        topics: [
            "Konsep ELIF",
            "Multiple Conditions",
            "Nested IF"
        ],
        color: "#9C27B0",
    },
    { // 23
        id: 23,
        title: "Latihan Percabangan - Kalkulator Sederhana",
        description: "Praktik membuat kalkulator sederhana dengan menggunakan percabangan IF, ELIF, ELSE.",
        level: "Pemula",
        duration: "2 jam",
        lessons: 3,
        progress: 0,
        image: "🧮",
        topics: [
            "Kalkulator Dasar",
            "Validasi Input",
            "Error Handling"
        ],
        color: "#FF5722",
    },
    { // 24
        id: 24,
        title: "For Loop (Perulangan)",
        description: "Belajar menggunakan for loop untuk melakukan perulangan dengan jumlah yang diketahui.",
        level: "Pemula",
        duration: "2 jam",
        lessons: 3,
        progress: 0,
        image: "🔄",
        topics: [
            "Konsep For Loop",
            "Loop dengan Range",
            "Loop dengan List"
        ],
        color: "#2196F3",
    },
    { // 25
        id: 25,
        title: "While Loop (Perulangan)",
        description: "Belajar menggunakan while loop untuk perulangan yang berhenti berdasarkan kondisi.",
        level: "Pemula",
        duration: "1.5 jam",
        lessons: 3,
        progress: 0,
        image: "⏳",
        topics: [
            "Konsep While Loop",
            "While vs For Loop",
            "Infinite Loop"
        ],
        color: "#FF9800",
    },
    { // 26
        id: 26,
        title: "Continue dan Pass",
        description: "Belajar menggunakan statement continue untuk melewati iterasi dan pass untuk placeholder.",
        level: "Pemula",
        duration: "1 jam",
        lessons: 3,
        progress: 0,
        image: "⏭️",
        topics: [
            "Continue Statement",
            "Pass Statement",
            "Perbedaan Continue vs Pass"
        ],
        color: "#4CAF50",
    },
    { // 27
        id: 27,
        title: "Break Statement",
        description: "Belajar menggunakan break untuk menghentikan loop secara paksa sebelum kondisi berakhir.",
        level: "Pemula",
        duration: "1 jam",
        lessons: 3,
        progress: 0,
        image: "⏹️",
        topics: [
            "Break Statement",
            "Break dalam For Loop",
            "Break dalam While Loop"
        ],
        color: "#F44336",
    },
    { // 28
        id: 28,
        title: "Latihan Perulangan",
        description: "Praktik mengintegrasikan for loop, while loop, break, dan continue dalam studi kasus nyata.",
        level: "Pemula Menengah",
        duration: "2 jam",
        lessons: 3,
        progress: 0,
        image: "💪",
        topics: [
            "Integrasi Loop",
            "Studi Kasus Nyata",
            "Optimasi Kode"
        ],
        color: "#795548",
    },
    { // 29
        id: 29,
        title: "List di Python",
        description: "Belajar dasar-dasar list, cara membuat, mengakses, dan operasi fundamental pada list.",
        level: "Pemula",
        duration: "2 jam",
        lessons: 3,
        progress: 0,
        image: "📋",
        topics: [
            "Pengenalan List",
            "Akses Element List",
            "Operasi Dasar List"
        ],
        color: "#3F51B5",
    },
    { // 30
        id: 30,
        title: "Manipulasi List",
        description: "Belajar memanipulasi list dengan method seperti append, insert, remove, sort, dan lainnya.",
        level: "Pemula",
        duration: "2 jam",
        lessons: 3,
        progress: 0,
        image: "🔧",
        topics: [
            "Method List Dasar",
            "Modifikasi List",
            "Sorting dan Searching"
        ],
        color: "#FF9800",
    },
    { // 31
        id: 31,
        title: "Operasi List di Python",
        description: "Belajar berbagai operasi dasar pada list seperti menambah, menghapus, mengubah, dan mengakses elemen.",
        level: "Pemula",
        duration: "1.5 jam",
        lessons: 3,
        progress: 0,
        image: "📋",
        topics: [
            "Apa itu List?",
            "Operasi Dasar List",
            "Method-Method List"
        ],
        color: "#FF6B6B",
    },
    { // 32
        id: 32,
        title: "Copy List di Python",
        description: "Memahami perbedaan antara shallow copy dan deep copy pada list, serta kapan menggunakannya.",
        level: "Pemula Menengah",
        duration: "1 jam",
        lessons: 3,
        progress: 0,
        image: "📑",
        topics: [
            "Shallow Copy",
            "Deep Copy",
            "Perbedaan dan Penggunaan"
        ],
        color: "#4ECDC4",
    },
    { // 33
        id: 33,
        title: "Nested List / List Bersarang",
        description: "Belajar bekerja dengan list di dalam list, akses elemen, dan manipulasi data multidimensi.",
        level: "Pemula Menengah",
        duration: "1.5 jam",
        lessons: 3,
        progress: 0,
        image: "📊",
        topics: [
            "Konsep Nested List",
            "Akses Elemen Nested List",
            "Manipulasi Nested List"
        ],
        color: "#45B7D1",
    },
    { // 34
        id: 34,
        title: "Deep Copy Nested List",
        description: "Memahami deep copy secara mendalam untuk nested list dan kapan harus menggunakannya.",
        level: "Menengah",
        duration: "1 jam",
        lessons: 3,
        progress: 0,
        image: "🔍",
        topics: [
            "Kebutuhan Deep Copy",
            "Implementasi Deep Copy",
            "Studi Kasus"
        ],
        color: "#96CEB4",
    },
    { // 35
        id: 35,
        title: "Looping List dan Enumerate",
        description: "Belajar berbagai cara iterasi melalui list menggunakan for loop, while loop, dan enumerate.",
        level: "Pemula",
        duration: "1.5 jam",
        lessons: 3,
        progress: 0,
        image: "🔄",
        topics: [
            "For Loop dengan List",
            "Enumerate Function",
            "While Loop dengan List"
        ],
        color: "#FECA57",
    },
    { // 36
        id: 36,
        title: "Latihan List",
        description: "Praktik comprehensive dengan berbagai operasi list melalui studi kasus dan problem solving.",
        level: "Pemula Menengah",
        duration: "2 jam",
        lessons: 3,
        progress: 0,
        image: "💪",
        topics: [
            "Manipulasi Data List",
            "Algoritma dengan List",
            "Studi Kasus Real World"
        ],
        color: "#FF9FF3",
    },
    { // 37
        id: 37,
        title: "Tuples dan Set",
        description: "Belajar tentang tuples (immutable sequences) dan sets (unordered collections dengan unique elements).",
        level: "Pemula",
        duration: "1.5 jam",
        lessons: 3,
        progress: 0,
        image: "🔒",
        topics: [
            "Tuples - Immutable Sequences",
            "Sets - Unique Collections",
            "Operasi Sets"
        ],
        color: "#54A0FF",
    }, 
    { // 38
        id: 38,
        title: "Dictionary",
        description: "Belajar tentang dictionary - struktur data key-value pairs yang powerful di Python.",
        level: "Pemula",
        duration: "1.5 jam",
        lessons: 3,
        progress: 0,
        image: "📚",
        topics: [
            "Pengenalan Dictionary",
            "Membuat dan Mengakses Dictionary",
            "Method-Method Dictionary"
        ],
        color: "#FF6B6B",
    },
    { // 39
        id: 39,
        title: "Operasi Dictionary",
        description: "Belajar berbagai operasi dan method dictionary untuk manipulasi data yang efektif.",
        level: "Pemula Menengah",
        duration: "1.5 jam",
        lessons: 3,
        progress: 0,
        image: "🛠️",
        topics: [
            "Method-Method Dictionary",
            "Dictionary Comprehension",
            "Advanced Operations"
        ],
        color: "#1DD1A1",
    },
    { // 40
        id: 40,
        title: "Looping Dictionary",
        description: "Belajar berbagai cara iterasi melalui dictionary menggunakan for loop, items(), keys(), dan values().",
        level: "Pemula",
        duration: "1 jam",
        lessons: 3,
        progress: 0,
        image: "🔄",
        topics: [
            "Basic Dictionary Iteration",
            "Iterasi dengan items()",
            "Advanced Looping Techniques"
        ],
        color: "#F368E0",
    }
];

export default lessonCards;